import './pdf-worker';
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import { LOCAL_STORAGE_KEYS } from "consts";
import { App } from "./app";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_BASE_URL,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    environment: process.env.REACT_APP_SENTRY_ENV,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Clean up localStorage when closing or reloading the page
const clearDocumentUploadStorage = () => {
  const localStorageKeys = [
    // Document upload
    LOCAL_STORAGE_KEYS.DOCUMENT_UPLOAD_PAGE_FROM_DATE,
    LOCAL_STORAGE_KEYS.DOCUMENT_UPLOAD_PAGE_TO_DATE,
    LOCAL_STORAGE_KEYS.DOCUMENT_UPLOAD_PAGE_SITES_FILTER,
    LOCAL_STORAGE_KEYS.DOCUMENT_UPLOAD_PAGE_DATA_ENTRIES_STATUS_FILTER,
    LOCAL_STORAGE_KEYS.DOCUMENT_UPLOAD_PAGE_PAGINATION,
    LOCAL_STORAGE_KEYS.DOCUMENT_UPLOAD_PAGE_COLUMN_FILTERS,

    // Document summary (Bill Entries)
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_PAGINATION,
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_START_DATE,
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_END_DATE,
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_SITES_FILTER,
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_COLUMN_FILTERS,
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_IS_EDITED,
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_IS_MY_TASK,
    LOCAL_STORAGE_KEYS.DOCUMENT_SUMMARY_PAGE_SHOW_DUPLICATES,
  ];

  localStorageKeys.forEach(k => localStorage.removeItem(k));
};

window.addEventListener('beforeunload', clearDocumentUploadStorage);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
